import { IProjectEstimateAtCompletion } from '../../interfaces/iproject-estimate-at-completion';
import { CostCodeCostType } from '../cost-code-cost-type';
import { Project } from '../project';

export class ProjectEstimateAtCompletionBase {
  ProjectEstimateAtCompletionId: number;
  EAC: number | null;
  Spend: number | null;
  CostCodeCostTypeId: number | null;
  ProjectId: number | null;
  StatusDate: Date | null;
  Pending: number | null;
  FieldCosts: number | null;
  CommittedCosts: number | null;
  ScheduleBasedCostPercentageComplete: number | null;
  UserInputWorkInPlaceValue: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  CostCodeCostType?: CostCodeCostType;
  Project?: Project;

  constructor(item?: IProjectEstimateAtCompletion) {
    if (item) {

      this.ProjectEstimateAtCompletionId = item.ProjectEstimateAtCompletionId;
      this.EAC = item.EAC;
      this.Spend = item.Spend;
      this.CostCodeCostTypeId = item.CostCodeCostTypeId;
      this.ProjectId = item.ProjectId;
      this.StatusDate = item.StatusDate ? new Date(item.StatusDate) : null;
      this.Pending = item.Pending;
      this.FieldCosts = item.FieldCosts;
      this.CommittedCosts = item.CommittedCosts;
      this.ScheduleBasedCostPercentageComplete = item.ScheduleBasedCostPercentageComplete;
      this.UserInputWorkInPlaceValue = item.UserInputWorkInPlaceValue;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.CostCodeCostType = new CostCodeCostType(item.CostCodeCostType);
      this.Project = new Project(item.Project);
    }
  }
}